// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetLatestChatFilesRequest,
  TGetLatestChatFilesModel,
  IMappers,
  TGetLatestChatFilesResponse,
  IGetLatestChatFilesResponse,
  IGetLatestChatFilesResponseError,
} from './types';

export const defaultConfig: TGetLatestChatFilesModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v1/get-latest-chat-files/',
} as TGetLatestChatFilesModel;

export function createGetLatestChatFilesModel(parameters: IGetLatestChatFilesRequest): TGetLatestChatFilesModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetLatestChatFilesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetLatestChatFilesRequest;
}

export async function fetchGetLatestChatFiles<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetLatestChatFilesOptions<TResponse200, TResponse400>): Promise<
  TGetLatestChatFilesResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetLatestChatFilesModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetLatestChatFilesResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetLatestChatFilesResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetLatestChatFilesResponse;
}
